import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_STORE_PAGE_NAME } from '../../../constants/service/app/recommendStoreConstants';
import RecommendStoreListContainer from '../../../containers/recommend/store/RecommendStoreListContainer';

const RecommendStoreList = () => {
  return (
    <PageTemplate pageName={RECOMMEND_STORE_PAGE_NAME.RECOMMEND_STORE_LIST}>
      <RecommendStoreListContainer />
    </PageTemplate>
  );
};

export default RecommendStoreList;
